(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["og-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-og-scroll-story]';
    const focusable = 'a[href], button, input, select, textarea, [tabindex]';
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const noTabIndex = '__none__';

    class OgScrollStory {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-story-track]');
        this.stage = root.querySelector('.og-scroll-story__stage');
        this.video = root.querySelector('.og-scroll-story__video');
        this.frameCanvas = root.querySelector('[data-story-frame-canvas]');
        this.frameContext = null;
        this.frameSequence = null;
        this.frameSequenceGeneration = 0;
        this.frameCache = new Map();
        this.frameLoads = new Map();
        this.frameDesiredIndex = 0;
        this.frameDrawnIndex = -1;
        this.frameCacheLimit = 6;
        this.frameWarmQueue = [];
        this.frameWarmActive = 0;
        this.frameWarmLimit = 4;
        this.frameWarmStarted = false;
        this.frameWarmTimer = 0;
        this.frameWarmUsesIdleCallback = false;
        this.frameWarmController = null;
        this.themePoster = root.querySelector('[data-theme-asset-poster]');
        this.skipLink = root.querySelector('.og-scroll-story__skip');
        this.endMarker = root.querySelector('.og-scroll-story__end');
        this.chapters = Array.from(root.querySelectorAll('[data-story-chapter]'));
        this.markers = Array.from(root.querySelectorAll('[data-story-marker]'));
        this.triggers = this.chapters.map((chapter) => clamp(Number(chapter.dataset.trigger || 0) / 100, 0, 1));
        this.activeIndex = -1;
        this.ticking = false;
        this.inView = false;
        this.mediaRequested = false;
        this.mediaSources = [];
        this.mediaSourceIndex = 0;
        this.currentMediaSource = '';
        this.desiredTime = null;
        this.lastAssignedTime = null;
        this.lastSeekWriteAt = 0;
        this.lastSeekDirection = 0;
        this.seekTimer = 0;
        this.seekFrame = 0;
        this.seekCadence = 1000 / 24;
        this.seekEpsilon = 1 / 48;
        this.mediaPrimed = false;
        this.mediaPrimePending = false;
        this.userGestureListening = false;
        this.skipResetFrame = 0;
        this.skipResetTimer = 0;
        this.previousScrollRestoration = null;
        this.geometryFrame = 0;
        this.renderFrame = 0;
        this.pendingResize = null;
        this.viewportOrientation = this.getViewportOrientation();
        this.onScroll = this.requestRender.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onMetadata = this.requestRender.bind(this);
        this.onFrameReady = this.handleFrameReady.bind(this);
        this.onSeeked = this.handleSeeked.bind(this);
        this.onMediaError = this.handleMediaError.bind(this);
        this.onUserGesture = this.handleUserGesture.bind(this);
        this.onSkip = this.handleSkip.bind(this);
        this.onSkipPageShow = this.resetSkipPosition.bind(this);
        this.onMotionChange = this.handleMotionChange.bind(this);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        this.onConnectionChange = this.handleMotionChange.bind(this);
        this.rememberTabOrder();
        this.start();
      }

      start() {
        this.root.ogScrollStory = this;
        if (!this.track || this.chapters.length === 0) return;
        this.clearPersistedSkipTarget();
        this.prepareThemePoster();
        if (this.skipLink) this.skipLink.addEventListener('click', this.onSkip);
        if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.onMotionChange);
        if (this.connection && this.connection.addEventListener) {
          this.connection.addEventListener('change', this.onConnectionChange);
        }
        this.handleMotionChange();
      }

      enhance() {
        if (this.root.dataset.enhanced === 'true') {
          this.requestRender();
          return;
        }
        this.root.dataset.enhanced = 'true';
        this.root.removeAttribute('data-reduced');
        this.root.removeAttribute('data-static');
        this.root.removeAttribute('data-static-media');
        this.activeIndex = -1;
        this.configureFrameSequence();
        this.listenForUserGesture();
        if (this.video) {
          this.video.pause();
          this.video.addEventListener('loadedmetadata', this.onMetadata);
          this.video.addEventListener('loadeddata', this.onFrameReady);
          this.video.addEventListener('seeked', this.onSeeked);
          this.video.addEventListener('error', this.onMediaError);
        }
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        window.addEventListener('pageshow', this.onResize);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onResize);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.track);
          this.resizeObserver.observe(this.root);
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.inView = entries.some((entry) => entry.isIntersecting);
              if (this.inView) {
                if (this.frameSequence) {
                  this.loadFrameSequence();
                } else {
                  this.loadMedia();
                }
                this.requestRender();
              }
            },
            { rootMargin: '120% 0px 120% 0px' }
          );
          this.observer.observe(this.root);
        } else {
          this.inView = true;
          if (this.frameSequence) {
            this.loadFrameSequence();
          } else {
            this.loadMedia();
          }
        }
        this.handleResize();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.root.isConnected) this.handleResize();
          });
        }
      }

      reduce() {
        this.root.dataset.reduced = 'true';
        this.root.removeAttribute('data-enhanced');
        this.root.removeAttribute('data-static');
        this.disconnectMotion();
        if (this.video) this.video.pause();
        this.activeIndex = -1;
        this.chapters.forEach((chapter) => {
          chapter.classList.add('is-active');
          chapter.setAttribute('aria-hidden', 'false');
          chapter.querySelectorAll(focusable).forEach((element) => this.restoreTabOrder(element));
        });
      }

      useStaticMode(reason) {
        this.root.dataset.static = reason;
        this.root.removeAttribute('data-enhanced');
        this.root.removeAttribute('data-reduced');
        this.disconnectMotion();
        if (this.video) this.video.pause();
        this.activeIndex = -1;
        this.chapters.forEach((chapter) => {
          chapter.classList.add('is-active');
          chapter.setAttribute('aria-hidden', 'false');
          chapter.querySelectorAll(focusable).forEach((element) => this.restoreTabOrder(element));
        });
      }

      handleMotionChange() {
        if (this.motionQuery.matches) {
          this.reduce();
        } else if (this.connection && this.connection.saveData) {
          this.useStaticMode('save-data');
        } else {
          this.enhance();
        }
      }

      loadMedia(force = false) {
        if (this.frameSequence) return;
        if (!this.video || (this.mediaRequested && !force)) return;

        if (this.video.querySelector('source[src]')) {
          this.mediaRequested = true;
          this.root.dataset.mediaTier = 'shopify';
          this.video.preload = 'auto';
          this.video.load();
          return;
        }

        const plan = this.createMediaPlan();
        if (!plan.length) return;
        if (force && this.currentMediaSource === plan[0].src && this.root.dataset.mediaTier === plan[0].tier) return;

        this.mediaRequested = true;
        this.mediaSources = plan;
        this.mediaSourceIndex = 0;
        this.loadCurrentMediaSource();
      }

      createMediaPlan() {
        const explicitDesktopSource = this.video.dataset.desktopSrc || '';
        const explicitPortraitSource = this.video.dataset.mobileSrc || '';
        const desktopSource = explicitDesktopSource || this.resolveThemeAssetUrl('ogdeals-scroll-desktop-1080p.mp4');
        if (!desktopSource) return [];

        const bundledLandscapeSource = explicitDesktopSource
          ? ''
          : this.resolveThemeAssetUrl('ogdeals-scroll-mobile-720p.mp4');
        const bundledPortraitPhone = explicitDesktopSource
          ? ''
          : this.resolveThemeAssetUrl('ogdeals-scroll-mobile-portrait-720p.mp4');
        const bundledPortraitTablet = explicitDesktopSource
          ? ''
          : this.resolveThemeAssetUrl('ogdeals-scroll-mobile-portrait-900p.mp4');
        const bundledPortraitFallback = explicitDesktopSource
          ? ''
          : this.resolveThemeAssetUrl('ogdeals-scroll-mobile-portrait-1080p.mp4');
        let portraitSource = explicitPortraitSource;
        if (!portraitSource && !explicitDesktopSource) {
          portraitSource = window.matchMedia('(max-width: 749px)').matches
            ? bundledPortraitPhone || bundledPortraitFallback
            : bundledPortraitTablet || bundledPortraitFallback;
        }
        const wideSource = explicitDesktopSource
          ? ''
          : this.resolveThemeAssetUrl('ogdeals-scroll-desktop-1440p.mp4');
        const usePortrait = window.matchMedia('(orientation: portrait) and (max-width: 1100px)').matches && portraitSource;
        const usePhoneLandscape =
          window.matchMedia(
            '(orientation: landscape) and (max-width: 932px), (orientation: landscape) and (max-height: 500px) and (pointer: coarse)'
          ).matches && bundledLandscapeSource;
        const slowConnection =
          this.connection && ['slow-2g', '2g', '3g'].includes(this.connection.effectiveType);
        const useWide =
          !usePortrait &&
          !usePhoneLandscape &&
          wideSource &&
          window.matchMedia(
            '(min-width: 1600px), (min-width: 1200px) and (min-resolution: 1.5dppx) and (pointer: fine)'
          ).matches &&
          !slowConnection;

        let primary = { src: desktopSource, tier: 'desktop' };
        if (usePortrait) primary = { src: portraitSource, tier: 'portrait' };
        if (usePhoneLandscape) primary = { src: bundledLandscapeSource, tier: 'mobile' };
        if (useWide) primary = { src: wideSource, tier: 'wide' };

        const fallbacks = [primary];
        if (usePortrait && bundledPortraitFallback) {
          fallbacks.push({ src: bundledPortraitFallback, tier: 'portrait' });
        }
        fallbacks.push(
          { src: desktopSource, tier: 'desktop' },
          { src: bundledLandscapeSource, tier: 'mobile' }
        );
        return fallbacks.filter(
          (candidate, index, candidates) =>
            candidate.src && candidates.findIndex((item) => item.src === candidate.src) === index
        );
      }

      loadCurrentMediaSource() {
        const candidate = this.mediaSources[this.mediaSourceIndex];
        if (!this.video || !candidate) return;
        this.currentMediaSource = candidate.src;
        this.root.dataset.mediaTier = candidate.tier;
        this.applyTierPoster(candidate.tier);
        this.root.removeAttribute('data-media-ready');
        this.root.removeAttribute('data-static-media');
        this.resetSeekState();
        this.mediaPrimed = false;
        this.mediaPrimePending = false;
        this.listenForUserGesture();
        this.video.preload = 'auto';
        this.video.src = candidate.src;
        this.video.load();
      }

      resolveThemeAssetUrl(filename) {
        if (this.root.dataset.themeAssets !== 'true') return '';
        const stylesheet = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).find((link) =>
          link.href.includes('/assets/og-brutal.css')
        );
        if (!stylesheet) return '';
        return new URL(filename, stylesheet.href).href;
      }

      prepareThemePoster() {
        if (!this.themePoster) return;
        this.themePosters = {
          desktop: this.resolveThemeAssetUrl('ogdeals-scroll-poster.jpg'),
          portrait: this.resolveThemeAssetUrl('ogdeals-scroll-mobile-portrait-poster.jpg')
        };
        const initialTier = window.matchMedia('(orientation: portrait) and (max-width: 1100px)').matches
          ? 'portrait'
          : 'desktop';
        this.root.dataset.mediaTier = initialTier;
        this.applyTierPoster(initialTier);
      }

      applyTierPoster(tier) {
        if (!this.themePoster || !this.themePosters) return;
        const posterSource =
          tier === 'portrait' && this.themePosters.portrait
            ? this.themePosters.portrait
            : this.themePosters.desktop;
        if (posterSource) this.themePoster.style.backgroundImage = `url("${posterSource}")`;
      }

      createFrameSequencePlan() {
        if (!this.frameCanvas || this.root.dataset.themeAssets !== 'true') return null;
        const hasTouch =
          navigator.maxTouchPoints > 0 || window.matchMedia('(pointer: coarse)').matches;
        if (!hasTouch) return null;

        const count = Number(this.frameCanvas.dataset.frameCount || 0);
        if (!Number.isFinite(count) || count < 2) return null;

        const portrait = window.matchMedia('(orientation: portrait)').matches;
        let template = '';
        let tier = '';
        let width = 0;
        let height = 0;

        if (portrait && window.matchMedia('(max-width: 749px)').matches) {
          template = this.frameCanvas.dataset.phoneFrameTemplate || '';
          tier = 'portrait';
          width = 720;
          height = 1280;
        } else if (portrait && window.matchMedia('(max-width: 1100px)').matches) {
          template = this.frameCanvas.dataset.tabletFrameTemplate || '';
          tier = 'portrait';
          width = 900;
          height = 1600;
        } else if (!portrait && window.matchMedia('(max-width: 1366px)').matches) {
          template = this.frameCanvas.dataset.landscapeFrameTemplate || '';
          tier = 'mobile';
          width = 1280;
          height = 720;
        }

        if (!template || !tier || !width || !height) return null;
        return {
          count,
          height,
          key: `${tier}:${width}x${height}:${template}`,
          template,
          tier,
          width
        };
      }

      configureFrameSequence() {
        const plan = this.createFrameSequencePlan();
        if (!plan) {
          if (this.frameSequence) this.deactivateFrameSequence();
          return false;
        }

        if (this.frameSequence && this.frameSequence.key === plan.key) {
          this.root.dataset.frameSequence = this.frameDrawnIndex >= 0 ? 'ready' : 'loading';
          this.root.dataset.mediaTier = plan.tier;
          return true;
        }

        if (this.frameSequence) this.deactivateFrameSequence();
        try {
          this.frameContext = this.frameCanvas.getContext('2d', {
            alpha: false,
            desynchronized: true
          });
        } catch (error) {
          this.frameContext = this.frameCanvas.getContext('2d');
        }
        if (!this.frameContext) return false;

        this.frameSequenceGeneration += 1;
        this.frameSequence = plan;
        this.frameCanvas.width = plan.width;
        this.frameCanvas.height = plan.height;
        this.frameCache.clear();
        this.frameLoads.clear();
        this.frameDesiredIndex = 0;
        this.frameDrawnIndex = -1;
        this.frameCacheLimit = plan.width >= 900 && plan.height >= 1600 ? 4 : 6;
        this.frameWarmQueue = [];
        this.frameWarmActive = 0;
        this.frameWarmStarted = false;
        this.frameWarmLimit =
          this.connection && ['slow-2g', '2g', '3g'].includes(this.connection.effectiveType) ? 2 : 4;
        this.root.dataset.frameSequence = 'loading';
        this.root.dataset.mediaTier = plan.tier;
        this.root.removeAttribute('data-media-ready');
        this.root.removeAttribute('data-static-media');
        this.applyTierPoster(plan.tier);
        if (this.video) this.video.pause();
        this.stopListeningForUserGesture();
        return true;
      }

      loadFrameSequence() {
        if (!this.frameSequence) return;
        this.renderFrameSequence(this.getProgress());
        this.scheduleFrameWarm();
      }

      renderFrameSequence(progress) {
        const sequence = this.frameSequence;
        if (!sequence) return;
        const index = clamp(Math.round(progress * (sequence.count - 1)), 0, sequence.count - 1);
        this.frameDesiredIndex = index;
        const cached = this.frameCache.get(index);
        if (cached) {
          this.cacheFrame(index, cached);
          this.drawFrame(index, cached);
          return;
        }

        const generation = this.frameSequenceGeneration;
        this.loadFrame(index, 'high').then((image) => {
          if (
            !image ||
            generation !== this.frameSequenceGeneration ||
            !this.frameSequence ||
            this.frameDesiredIndex !== index
          ) {
            return;
          }
          this.drawFrame(index, image);
        });
      }

      loadFrame(index, priority = 'auto') {
        const cached = this.frameCache.get(index);
        if (cached) return Promise.resolve(cached);
        const pending = this.frameLoads.get(index);
        if (pending) return pending;
        if (!this.frameSequence) return Promise.resolve(null);

        const generation = this.frameSequenceGeneration;
        const source = this.buildFrameUrl(this.frameSequence.template, index);
        const request = new Promise((resolve) => {
          const image = new Image();
          image.decoding = 'async';
          if ('fetchPriority' in image) image.fetchPriority = priority;
          image.onload = () => {
            const finish = () => {
              if (generation !== this.frameSequenceGeneration || !this.frameSequence) {
                resolve(null);
                return;
              }
              this.frameLoads.delete(index);
              this.cacheFrame(index, image);
              resolve(image);
            };
            if (image.decode) {
              image.decode().catch(() => null).then(finish);
            } else {
              finish();
            }
          };
          image.onerror = () => {
            if (generation === this.frameSequenceGeneration) {
              this.frameLoads.delete(index);
              if (this.frameDrawnIndex < 0 && this.frameDesiredIndex === index) {
                this.deactivateFrameSequence();
                if (this.inView) this.loadMedia(true);
                this.requestRender();
              }
            }
            resolve(null);
          };
          image.src = source;
        });
        this.frameLoads.set(index, request);
        return request;
      }

      cacheFrame(index, image) {
        this.frameCache.delete(index);
        this.frameCache.set(index, image);
        while (this.frameCache.size > this.frameCacheLimit) {
          let removed = false;
          for (const key of this.frameCache.keys()) {
            if (key === this.frameDesiredIndex || key === this.frameDrawnIndex) continue;
            this.frameCache.delete(key);
            removed = true;
            break;
          }
          if (!removed) break;
        }
      }

      drawFrame(index, image) {
        if (!this.frameSequence || !this.frameContext || !image.naturalWidth || !image.naturalHeight) return;
        try {
          this.frameContext.clearRect(0, 0, this.frameCanvas.width, this.frameCanvas.height);
          this.frameContext.drawImage(image, 0, 0, this.frameCanvas.width, this.frameCanvas.height);
        } catch (error) {
          return;
        }
        this.frameDrawnIndex = index;
        this.root.dataset.frameSequence = 'ready';
        this.root.dataset.mediaReady = 'true';
      }

      buildFrameUrl(template, index) {
        const frameNumber = String(index + 1).padStart(3, '0');
        return template.replace(/001(?=\.webp(?:\?|$))/, frameNumber);
      }

      scheduleFrameWarm() {
        if (!this.frameSequence || this.frameWarmStarted || this.frameWarmTimer) return;
        const start = () => {
          this.frameWarmTimer = 0;
          this.frameWarmUsesIdleCallback = false;
          this.startFrameWarm();
        };
        if ('requestIdleCallback' in window) {
          this.frameWarmUsesIdleCallback = true;
          this.frameWarmTimer = window.requestIdleCallback(start, { timeout: 700 });
        } else {
          this.frameWarmTimer = window.setTimeout(start, 120);
        }
      }

      startFrameWarm() {
        const sequence = this.frameSequence;
        if (!sequence || this.frameWarmStarted) return;
        this.frameWarmStarted = true;
        this.frameWarmController = 'AbortController' in window ? new AbortController() : null;
        const queued = new Set();
        const queue = [];
        const add = (index) => {
          const safeIndex = clamp(index, 0, sequence.count - 1);
          if (queued.has(safeIndex)) return;
          queued.add(safeIndex);
          queue.push(safeIndex);
        };

        add(0);
        this.triggers.forEach((trigger) => add(Math.round(trigger * (sequence.count - 1))));
        add(sequence.count - 1);
        for (let offset = 1; offset < sequence.count; offset += 1) {
          add((this.frameDesiredIndex + offset) % sequence.count);
          add((this.frameDesiredIndex - offset + sequence.count) % sequence.count);
        }
        this.frameWarmQueue = queue;
        this.pumpFrameWarm();
      }

      pumpFrameWarm() {
        const sequence = this.frameSequence;
        const generation = this.frameSequenceGeneration;
        if (!sequence || !this.frameWarmStarted || generation <= 0) return;

        while (this.frameWarmActive < this.frameWarmLimit && this.frameWarmQueue.length) {
          const index = this.frameWarmQueue.shift();
          if (this.frameCache.has(index) || this.frameLoads.has(index)) continue;
          this.frameWarmActive += 1;
          fetch(this.buildFrameUrl(sequence.template, index), {
            cache: 'force-cache',
            credentials: 'same-origin',
            ...(this.frameWarmController ? { signal: this.frameWarmController.signal } : {})
          })
            .then((response) => {
              if (!response.ok) throw new Error(`Frame request failed: ${response.status}`);
              return response.arrayBuffer();
            })
            .catch(() => null)
            .finally(() => {
              if (generation !== this.frameSequenceGeneration || !this.frameSequence) return;
              this.frameWarmActive = Math.max(0, this.frameWarmActive - 1);
              this.pumpFrameWarm();
            });
        }
      }

      cancelFrameWarm() {
        if (this.frameWarmController) this.frameWarmController.abort();
        this.frameWarmController = null;
        if (this.frameWarmTimer) {
          if (this.frameWarmUsesIdleCallback && 'cancelIdleCallback' in window) {
            window.cancelIdleCallback(this.frameWarmTimer);
          } else {
            window.clearTimeout(this.frameWarmTimer);
          }
        }
        this.frameWarmTimer = 0;
        this.frameWarmUsesIdleCallback = false;
        this.frameWarmQueue = [];
        this.frameWarmActive = 0;
        this.frameWarmStarted = false;
      }

      deactivateFrameSequence() {
        if (!this.frameSequence && !this.root.hasAttribute('data-frame-sequence')) return;
        this.frameSequenceGeneration += 1;
        this.cancelFrameWarm();
        this.frameSequence = null;
        this.frameCache.clear();
        this.frameLoads.clear();
        this.frameDesiredIndex = 0;
        this.frameDrawnIndex = -1;
        this.root.removeAttribute('data-frame-sequence');
        this.root.removeAttribute('data-media-ready');
        if (this.frameContext && this.frameCanvas) {
          this.frameContext.clearRect(0, 0, this.frameCanvas.width, this.frameCanvas.height);
        }
      }

      handleFrameReady() {
        if (this.frameSequence) return;
        const progress = this.getProgress();
        if (progress <= 0.002) this.root.dataset.mediaReady = 'true';
        this.primeMedia();
        this.requestRender();
      }

      handleSeeked() {
        if (this.frameSequence) return;
        this.root.dataset.mediaReady = 'true';
        this.flushSeek();
        this.requestRender();
      }

      handleMediaError() {
        if (this.mediaSourceIndex + 1 < this.mediaSources.length) {
          this.mediaSourceIndex += 1;
          this.loadCurrentMediaSource();
          return;
        }
        this.root.dataset.staticMedia = 'true';
        this.root.removeAttribute('data-media-ready');
        this.resetSeekState();
        if (this.video) this.video.pause();
      }

      clearPersistedSkipTarget() {
        if (!this.endMarker || window.location.hash !== `#${this.endMarker.id}`) return;
        if (window.history && window.history.replaceState) {
          if ('scrollRestoration' in window.history) {
            this.previousScrollRestoration = window.history.scrollRestoration;
            window.history.scrollRestoration = 'manual';
          }
          window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        }
        this.resetSkipPosition();
        window.addEventListener('pageshow', this.onSkipPageShow, { once: true });
        this.skipResetFrame = window.requestAnimationFrame(() => {
          this.skipResetFrame = 0;
          this.resetSkipPosition();
        });
        this.skipResetTimer = window.setTimeout(() => {
          this.skipResetTimer = 0;
          this.resetSkipPosition();
          this.restoreScrollRestoration();
        }, 800);
      }

      resetSkipPosition() {
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.requestRender();
      }

      restoreScrollRestoration() {
        window.removeEventListener('pageshow', this.onSkipPageShow);
        if (this.skipResetFrame) window.cancelAnimationFrame(this.skipResetFrame);
        if (this.skipResetTimer) window.clearTimeout(this.skipResetTimer);
        this.skipResetFrame = 0;
        this.skipResetTimer = 0;
        if (this.previousScrollRestoration !== null && 'scrollRestoration' in window.history) {
          window.history.scrollRestoration = this.previousScrollRestoration;
        }
        this.previousScrollRestoration = null;
      }

      handleSkip(event) {
        if (this.root.dataset.enhanced !== 'true' || !this.endMarker) return;
        event.preventDefault();
        this.endMarker.scrollIntoView({ block: 'start', behavior: 'instant' });
        try {
          this.endMarker.focus({ preventScroll: true });
        } catch (error) {
          this.endMarker.focus();
        }
      }

      handleResize() {
        const orientation = this.getViewportOrientation();
        const scrollPosition = this.getScrollPosition();
        if (!this.pendingResize) {
          const hasGeometry = Number.isFinite(this.startPosition) && Number.isFinite(this.distance);
          const previousProgress = hasGeometry ? this.getProgress() : 0;
          const wasWithinStory =
            hasGeometry &&
            scrollPosition >= this.startPosition &&
            scrollPosition <= this.startPosition + this.distance;
          this.pendingResize = {
            previousOrientation: this.viewportOrientation,
            previousProgress,
            wasWithinStory,
            orientation
          };
        } else {
          this.pendingResize.orientation = orientation;
        }

        if (this.geometryFrame) return;
        this.geometryFrame = window.requestAnimationFrame(() => {
          const resizeState = this.pendingResize;
          this.pendingResize = null;
          this.geometryFrame = 0;
          const rect = this.track.getBoundingClientRect();
          this.startPosition = this.getScrollPosition() + rect.top;
          const stageHeight = this.stage ? this.stage.offsetHeight : window.innerHeight;
          this.distance = Math.max(1, this.track.offsetHeight - stageHeight);
          const orientationChanged =
            resizeState.previousOrientation && resizeState.previousOrientation !== resizeState.orientation;
          this.viewportOrientation = resizeState.orientation;
          if (orientationChanged && resizeState.wasWithinStory) {
            const target = this.startPosition + resizeState.previousProgress * this.distance;
            window.scrollTo({ top: target, behavior: 'instant' });
          }
          const frameSequenceActive = this.configureFrameSequence();
          if (frameSequenceActive) {
            if (this.inView) this.loadFrameSequence();
          } else if (this.inView && this.root.dataset.mediaTier !== 'shopify') {
            this.loadMedia(true);
          }
          this.requestRender();
        });
      }

      getViewportOrientation() {
        return window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait';
      }

      getScrollPosition() {
        const scrollingElement = document.scrollingElement;
        if (scrollingElement && Number.isFinite(scrollingElement.scrollTop)) return scrollingElement.scrollTop;
        if (Number.isFinite(window.scrollY)) return window.scrollY;
        return document.documentElement.scrollTop || document.body.scrollTop || 0;
      }

      getProgress() {
        if (!Number.isFinite(this.startPosition) || !Number.isFinite(this.distance)) return 0;
        return clamp((this.getScrollPosition() - this.startPosition) / this.distance, 0, 1);
      }

      requestRender() {
        if (this.ticking || this.root.dataset.enhanced !== 'true') return;
        this.ticking = true;
        this.renderFrame = window.requestAnimationFrame(() => {
          this.render();
          this.ticking = false;
          this.renderFrame = 0;
        });
      }

      render() {
        const progress = this.getProgress();
        this.root.style.setProperty('--og-story-progress', progress.toFixed(4));
        let nextIndex = 0;
        let nextTrigger = -1;
        this.triggers.forEach((trigger, index) => {
          if (progress >= trigger && trigger >= nextTrigger) {
            nextIndex = index;
            nextTrigger = trigger;
          }
        });
        this.setActive(nextIndex);
        if (this.frameSequence) {
          this.renderFrameSequence(progress);
          return;
        }
        if (!this.video || !Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        const endOffset = progress >= 1 ? 0.04 : 0;
        const targetTime = clamp(this.video.duration * progress - endOffset, 0, this.video.duration);
        this.desiredTime = targetTime;
        this.flushSeek();
      }

      flushSeek() {
        if (
          !this.video ||
          !Number.isFinite(this.desiredTime) ||
          !Number.isFinite(this.video.duration) ||
          this.video.duration <= 0 ||
          this.video.readyState < 1
        ) {
          return;
        }

        const targetTime = clamp(this.desiredTime, 0, this.video.duration);
        const referenceTime = Number.isFinite(this.lastAssignedTime) ? this.lastAssignedTime : this.video.currentTime;
        const delta = targetTime - referenceTime;
        const direction = Math.abs(delta) > this.seekEpsilon ? Math.sign(delta) : 0;
        const directionChanged =
          direction !== 0 && this.lastSeekDirection !== 0 && direction !== this.lastSeekDirection;
        const now = window.performance && window.performance.now ? window.performance.now() : Date.now();
        const wait = this.seekCadence - (now - this.lastSeekWriteAt);

        if (directionChanged) this.cancelScheduledSeek();
        if (!directionChanged && wait > 1) {
          this.scheduleSeek(wait);
          return;
        }
        if (Math.abs(delta) <= this.seekEpsilon && Math.abs(this.video.currentTime - targetTime) <= this.seekEpsilon) {
          return;
        }

        try {
          this.lastAssignedTime = targetTime;
          this.lastSeekWriteAt = now;
          if (direction !== 0) this.lastSeekDirection = direction;
          this.video.currentTime = targetTime;
          if (this.video.readyState >= 2) this.root.dataset.mediaReady = 'true';
        } catch (error) {
          if (error.name !== 'InvalidStateError') this.handleMediaError();
        }
      }

      scheduleSeek(delay) {
        if (this.seekTimer || this.seekFrame) return;
        const queueFrame = () => {
          this.seekTimer = 0;
          this.seekFrame = window.requestAnimationFrame(() => {
            this.seekFrame = 0;
            this.flushSeek();
          });
        };
        if (delay > 1) {
          this.seekTimer = window.setTimeout(queueFrame, delay);
        } else {
          queueFrame();
        }
      }

      cancelScheduledSeek() {
        if (this.seekTimer) window.clearTimeout(this.seekTimer);
        if (this.seekFrame) window.cancelAnimationFrame(this.seekFrame);
        this.seekTimer = 0;
        this.seekFrame = 0;
      }

      primeMedia(force = false) {
        if (this.mediaPrimed || this.mediaPrimePending || !this.video) return;
        if (!force && this.video.readyState < 2) return;
        this.mediaPrimePending = true;
        this.video.muted = true;
        this.video.playsInline = true;
        const primedSource = this.currentMediaSource;
        const playAttempt = this.video.play();
        if (!playAttempt || !playAttempt.then) {
          this.video.pause();
          this.mediaPrimePending = false;
          this.mediaPrimed = true;
          this.stopListeningForUserGesture();
          this.requestRender();
          return;
        }
        playAttempt
          .then(() => {
            this.video.pause();
            this.mediaPrimePending = false;
            if (primedSource !== this.currentMediaSource || this.root.dataset.enhanced !== 'true') return;
            this.mediaPrimed = true;
            this.stopListeningForUserGesture();
            this.requestRender();
          })
          .catch(() => {
            this.mediaPrimePending = false;
            this.mediaPrimed = false;
            if (this.root.dataset.enhanced === 'true') this.listenForUserGesture();
            this.requestRender();
          });
      }

      handleUserGesture() {
        if (this.root.dataset.enhanced !== 'true' || this.mediaPrimed) return;
        if (this.frameSequence) {
          this.loadFrameSequence();
          return;
        }
        this.loadMedia();
        this.primeMedia(true);
      }

      listenForUserGesture() {
        if (this.userGestureListening || !this.video || this.mediaPrimed || this.frameSequence) return;
        this.userGestureListening = true;
        window.addEventListener('touchend', this.onUserGesture, { passive: true, capture: true });
        window.addEventListener('click', this.onUserGesture, true);
        window.addEventListener('keydown', this.onUserGesture, true);
      }

      stopListeningForUserGesture() {
        if (!this.userGestureListening) return;
        window.removeEventListener('touchend', this.onUserGesture, true);
        window.removeEventListener('click', this.onUserGesture, true);
        window.removeEventListener('keydown', this.onUserGesture, true);
        this.userGestureListening = false;
      }

      resetSeekState() {
        this.cancelScheduledSeek();
        this.desiredTime = null;
        this.lastAssignedTime = null;
        this.lastSeekWriteAt = 0;
        this.lastSeekDirection = 0;
      }

      setActive(index) {
        if (index === this.activeIndex) return;
        const outgoingChapter = this.chapters[this.activeIndex];
        if (outgoingChapter && outgoingChapter.contains(document.activeElement) && this.skipLink) {
          try {
            this.skipLink.focus({ preventScroll: true });
          } catch (error) {
            this.skipLink.focus();
          }
        }
        this.activeIndex = index;
        this.chapters.forEach((chapter, chapterIndex) => {
          const active = chapterIndex === index;
          chapter.classList.toggle('is-active', active);
          chapter.setAttribute('aria-hidden', active ? 'false' : 'true');
          chapter.querySelectorAll(focusable).forEach((element) => {
            if (active) {
              this.restoreTabOrder(element);
            } else {
              element.setAttribute('tabindex', '-1');
            }
          });
        });
        this.markers.forEach((marker, markerIndex) => marker.classList.toggle('is-active', markerIndex === index));
      }

      rememberTabOrder() {
        this.chapters.forEach((chapter) => {
          chapter.querySelectorAll(focusable).forEach((element) => {
            if (element.hasAttribute('data-og-original-tabindex')) return;
            element.dataset.ogOriginalTabindex = element.hasAttribute('tabindex')
              ? element.getAttribute('tabindex')
              : noTabIndex;
          });
        });
      }

      restoreTabOrder(element) {
        const original = element.dataset.ogOriginalTabindex;
        if (original === noTabIndex || original === undefined) {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', original);
        }
      }

      revealBlock(chapter) {
        const index = this.chapters.indexOf(chapter);
        if (index < 0) return;
        if (this.root.dataset.enhanced === 'true') {
          const trigger = this.triggers[index] || 0;
          window.scrollTo({ top: this.startPosition + trigger * this.distance, behavior: 'instant' });
          this.setActive(index);
        } else {
          chapter.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      }

      disconnectMotion() {
        this.stopListeningForUserGesture();
        this.mediaPrimePending = false;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onResize);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onResize);
        if (this.video) {
          this.video.removeEventListener('loadedmetadata', this.onMetadata);
          this.video.removeEventListener('loadeddata', this.onFrameReady);
          this.video.removeEventListener('seeked', this.onSeeked);
          this.video.removeEventListener('error', this.onMediaError);
        }
        this.resetSeekState();
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        if (this.geometryFrame) window.cancelAnimationFrame(this.geometryFrame);
        if (this.renderFrame) window.cancelAnimationFrame(this.renderFrame);
        this.geometryFrame = 0;
        this.renderFrame = 0;
        this.pendingResize = null;
        this.ticking = false;
        this.deactivateFrameSequence();
      }

      destroy() {
        this.restoreScrollRestoration();
        this.disconnectMotion();
        if (this.skipLink) this.skipLink.removeEventListener('click', this.onSkip);
        if (this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this.onMotionChange);
        if (this.connection && this.connection.removeEventListener) {
          this.connection.removeEventListener('change', this.onConnectionChange);
        }
        delete this.root.ogScrollStory;
      }
    }

    const init = (scope = document) => {
      const roots = [];
      if (scope.matches && scope.matches(selector)) roots.push(scope);
      if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(selector));
      roots.forEach((root) => {
        if (!root.ogScrollStory) new OgScrollStory(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      if (root && root.ogScrollStory) root.ogScrollStory.destroy();
    });
    document.addEventListener('shopify:block:select', (event) => {
      const chapter = event.target.closest ? event.target.closest('[data-story-chapter]') : null;
      const root = chapter ? chapter.closest(selector) : null;
      if (root && root.ogScrollStory) root.ogScrollStory.revealBlock(chapter);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
